export const {
  NODE_ENV,
  REACT_APP_ELASTIC_URL,
  REACT_APP_ELASTIC_CREDENTIALS,
  REACT_APP_ELASTIC_AUTH_TOKEN,
  REACT_APP_DEV_BUILD
} = process.env;